import React, { createContext, useState, useContext } from "react";

const PermissionContext = createContext(false);

const PermissionContextProvider = ({children}) => {
    const [permissions, setPermissions] = useState([]);

    return (
        <PermissionContext.Provider value={{permissions, setPermissions}} >
            {children}
        </PermissionContext.Provider>
    );
}

const usePermissionContext = () => {
    const context = useContext(PermissionContext);
    if (context === undefined) {
        throw new Error("usePermissionContext must be used within a PermissionContextProvider");
    }

    return context;
}

export { PermissionContextProvider, usePermissionContext };
